import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="432.952"
      height="1262.686"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 432.952 1262.686"
      xmlSpace="preserve"
      className='clickable'
    >
      <clipPath id="ArtboardFrame">
        <path d="M0 0H2800V2160H0z"></path>
      </clipPath>
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#ArtboardFrame)"
        transform="translate(-1547.358 -897.314)"
      >
        <path
          strokeWidth="3"
          d="M1633.82 1129.55s3.03 51.96 13.38 93.68c10.35 41.72 28.02 73.19 28.02 73.19l-7.53 6.69"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1643.02 1125.16s3.97 53.84 15.26 95.98c11.29 42.13 31.58 73.6 31.58 73.6s18.33-7.64 35.96-10.45c14.43-2.3 34.5-.21 34.5-.21"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1764.69 1102.01s-13.78 27.17-12.73 69.99c1.05 42.81 10.87 103.5 10.87 103.5"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1770.15 1109.89s-7.58 29.44-7.32 65.66c.26 36.23 8.37 79.25 8.37 79.25"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1671.87 1311.47s18.21-7.84 39.65-12.33c21.43-4.5 46.09-5.65 46.09-5.65"
          opacity="1"
        ></path>
        <path strokeWidth="3" d="M1834.86 1280.66l19.48-.94" opacity="1"></path>
        <path
          strokeWidth="3"
          d="M1831.07 1291.51l24.04-1.83"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1701.8 1390.57s-.23-3.75 11.64-4.7c11.88-.96 19.61 2.63 35.85.89 16.24-1.73 25.09-7.39 25.09-7.39"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1783.13 1632.18s3.73-8.03 24.46-16.06c16-6.2 36.6-15.31 36.6-15.31"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1786.12 1643.01s13.77-9.24 29.22-16.99c15.45-7.75 32.58-14.01 32.58-14.01"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1865.85 1592.78s9.36-2.92 20.38-4.09c11.01-1.17 23.69-.58 23.69-.58"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1869.21 1603.79s10.73-3.12 21.47-4.33c10.74-1.22 21.48-.52 21.48-.52"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1799.75 1669.71s12.79-9.34 28.01-16.81c15.22-7.47 32.86-13.07 32.86-13.07"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1801.24 1680.73s16.03-10.8 31.02-17.71c14.98-6.9 27.6-9.66 27.6-9.66"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1878.51 1636.26s5.45-2.7 15.26-5.12c9.8-2.41 20.13-2.99 20.13-2.99"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1881.48 1646.17s6.15-2.41 15.51-4.68c9.36-2.27 18.31-3.13 18.31-3.13"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M1852.55 1612l9.3 27.22" opacity="1"></path>
        <path
          strokeWidth="1"
          d="M1862.93 1609.64l9.86 26.15"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1862.24 1598.04c1.22.22 3.75-.59 4.04-1.2.31-.66-.65-4.97-1.69-5.09-3.23-.34-19.11 4.89-20.16 6.9-1.27 2.45 2.89 12.01 3.91 13.63.87 1.4 14.61-3.28 20-5.08 1.84-.61.09-5.81-.42-6.38-.52-.56-3.37.34-4.38 1.15-1 .8.81 2.31.05 2.81-1.04.7-12.61 4.6-12.61 4.6l-3.14-9.16s12.03-4.48 13.17-4.45c.83.02 0 2.05 1.23 2.27z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1874.99 1641.4c1.22.22 3.76-.58 4.05-1.2.3-.66-.65-4.97-1.69-5.08-3.23-.35-19.11 4.89-20.16 6.9-1.28 2.44 2.89 12 3.9 13.63.88 1.4 14.62-3.28 20.01-5.08 1.83-.61.09-5.81-.43-6.38-.51-.57-3.36.33-4.37 1.14-1 .81.81 2.31.05 2.82-1.04.69-12.62 4.6-12.62 4.6l-3.14-9.16s12.04-4.48 13.18-4.45c.83.02 0 2.05 1.22 2.26z"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1669.79 1306.04c1.17 1.16 2.33 2.33 3.5 3.5 2.33 2.33 3.5 4.43 3.5 6.3 0 1.86 1.63 5.83 4.9 11.9 3.27 6.06 5.13 15.63 5.6 28.7.47 13.06 3.5 21 9.1 23.8 5.6 2.8 7.7 6.53 6.3 11.2-1.4 4.66-1.87 8.16-1.4 10.5.47 2.33-.47 5.6-2.8 9.8-1.17 2.1-2.33 4.2-3.5 6.3-2.1-6.54-4.2-13.07-6.3-19.6-4.2-13.07-6.3-23.1-6.3-30.1s-.7-10.74-2.1-11.2c-1.4-.47-3.5-9.1-6.3-25.9l-4.2-25.2z"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1931.71 1457.77c.85-6.85-3.7-13.56-4.18-20.04-.73-9.75-1.03-16.12-2.06-26.02-.58-5.49-.52-12.04-5.02-16.66-4.42-4.52-14.37-8.82-19.66-12.33-2.75-1.83-1.68-2.37-3.96-4.7-3.42-3.51-12.96-9.26-16.4-10.93-3.44-1.68-1.08-3-2.51-4.83-1.34-1.72-4.54-1.27-5.2-3.14-.82-2.31 4.08-.22 2.29-5.28-1.4-3.96-4.15-9.6-6.14-15.33-1.82-5.28-2.91-10.63-3.78-14.93-1.1-5.47-1.74-12.27-2.99-17.72-1.12-4.86-3.87-8.11-4.25-13.13-.2-2.69-.08-5.12-.28-7.83-.17-2.25-1.77-4.31-1.87-6.57-.18-4.29 1.99-8.22 2.5-12.36 1.33-10.69.78-38.85.39-42.58-1.66-15.93-1.81-32.62.15-48.46.45-3.71 2.61-12.82 2.77-12.88l-2.76-.11c0-1.15 1.01-2.68.81-4.15-.63-4.62-3.31-10.2-5.52-14.44-2.85-5.44-6.95-9.06-7.78-9.81-10.84-9.74-19.02-10.06-29.36-14.76-3.18-1.44-8.56-4.2-11.27-6.46-.86-.73-.91-2.03-3.16-3.42-6.26-3.86-10.9 3.2-14.49 3.71-4.64.66-8.47-1.1-12.19-2.96-5.85-2.93-10.67-7.51-12-14.17-.16-.8.87-6.88 3.66-9.74 2.25-2.31 5.61-3.48 6.37-3.53 5.96-.41 12.13.67 17.32-1.35 7.98-3.11 11.58-13.31 13.33-17.23 6.15-13.73 7.63-18.44 8.42-25.45.4-3.56-.02-7.83 1.19-13.9 1.27-6.32 5.46-3.97 5.33-17.15-.07-7.91-6.62-9.36-5.58-14.54.58-2.915 2.05-5.825 2.81-6.039.76-.214.8 2.268 1.44 4.14.11.312 6.46-2.334 6.83-2.533 5.66-2.994 5.7-10.351 5.13-15.54-1.18-10.571-12-12.829-16.93-20.72-2.71-4.325-4.78-8.605-6.39-13.426-1.13-3.395-3.3-7.023-5.55-10.026-4.37-5.828-8.34-4.612-13.97-8.13-3.45-2.155-7.91-6.582-12.01-7.401-4.43-.887-7.88-1.816-12.55-3.15-4.64-1.326-8.33-8.107-12.83-9.392-7.71-2.204-16.87 2.869-20.78 9.395-1.05 1.739-6.26 8.662-6.26 8.662-3.17-6.349-17.22-6.843-23.28-6.339-.92.077-6.27-.636-6.83.488-.41.833 1.95 1.464 1.1 2.316-.67.674-2.79.409-3.78.975-3.4 1.946-8.64 6.309-10.97 9.63-2.99 4.271-3.57 9.21-5.85 13.774-1.49 2.983-5.11 4.662-7.56 7.313-6.15 6.661-6.42 14.488-9.66 21.605-2.74 6.024-9.81 11.092-13.56 16.342-2.27 3.172-1.77 8.811-.94 15.486.92 7.36 2.37 15.8 3.74 19.56 1.42 3.9 12.45 6.01 17.13 5.07 3.23-.65-6.97-5.71-3.9-6.15 2.47-.35 5.39 1 6.74 3.05 1.63 2.45 3 5.48 4.37 7.43 2.15 3.08 4.92 6.38 7.75 8.9 5.11 4.54 10.07 7.37 15.88 10.85 5.69 3.42 9.96 9.85 8.41 16.83-.53 2.39-6.67 6.76-6.22 7.67 1.07 2.13 5.59 1.29 7.2.49l-.57 2.23c-.99 3.29-2.79 5.63-5.33 6.98-3.37 1.78-7.86.87-11.76 2.06-2.89.88-7.29 4.77-9.42 6.82-5.62 5.42-9.27 12.14-15.68 16.87-6.52 4.82-12.02 9.73-18.91 13.92-4.49 2.73-22.09 18.03-25 21.5-5.22 6.24-4.21 11.52-6.02 21.23 0 0-.6 20.22-.9 25.69-.7 13.19-1.15 26.18-.69 39.36.36 10.44 1.07 21.52 1.68 31.99.59 10.19 8.79 63.37 10.05 73.4 1.02 8.22.56 16.74 1.74 24.96.34 2.39-.29 5.44.58 7.58.42 1.05 1.78 2.46 2.06 3.56 3 12 3.78 24.41 5.02 36.87 1.59 15.98 1.34 30.49 1.86 45.46.27 7.93.13 20.81.94 32.31.49 6.96 1.9 13.28 2.3 18.11.17 2.01 4.16 4.35 4.91 6.3 1.81 4.68 1.16 14.12 1.8 17.36.99 4.92 2.77 5.13 3.72 9.88.98 4.88-.11 14.01-.89 15.74-.78 1.74-4.61 13.58-3.59 18.25 1.02 4.7 4.06 9.3 7.27 13.94 3.21 4.64 10.06 10.18 9.29 15.72-2.68 19.27-7.79 70.54-10.28 75.53l10.99-77.63c2.23-4.46 1.57-11.19 2.39-16.1 2.2-13.23 8.87-27.85 6.55-41.73-2.27-13.66-9.42-28.62-6.55-42.93 1.33-6.68 3.15-13.37 4.47-19.97 2.76-13.8 13.43-31.33 19.67-43.82 2.43-4.85 4.2-10.27 7.45-14.61 1.24-1.64 4.82-5.46 4.77-5.36"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1921.48 1495.63c-10.11 13.54-6.07 30.95-6.28 46.39-.1 7.91-.59 18.63-.44 26.61.21 10.74.03 18.64 2.08 29.36.79 4.14 2.4 6.26 2.82 10.51.44 4.32.7 11.24-.33 15.74-.37 1.62-2.31 3.14-2.28 4.58.04 2.1 2.42-1.53 2.47.9.04 2.17 1.05 7.96 1.02 10.15-.02 1.96 4.22 16.53 5.63 26.97 2.51 18.51 2.42 35.56 5.63 62.36.75 6.26 8.27 61.82 9.45 65.76"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1780.2 1631.47c-.84 2.27 4.14 6.25 5.01 8.59 1.66 4.5 1.44 8.7 3.81 13.14 2.25 4.22 7.3 7.74 8.83 12.58 1.58 4.99 1.82 10.56 3.39 15.55 9.33 29.47 22.84 59.39 35.08 88.29 13.51 31.92.8 66.32 6.8 99.18 7.38 40.48 25.34 77.17 40.68 114.78 10.5 25.72 18.79 52.72 28.21 78.2 1.01 2.73 6.36 3.65 8.43 5.86 3.58 3.81 3.83 9.55 6.6 13.84"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1779.79 1632.98c1.14 5.33-4.36 14.76-6.16 19.79-3.87 10.82-7.04 21.47-11.11 32.18-16.83 44.26-35.82 87.14-58.52 128.93-5.17 9.53-13.08 20.38-20.63 28.32-2.34 2.47-9.08 8.04-9.88 11.12"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1575.74 2050.92c-.73 7.99-3.66 15.81-5.18 23.73-1.61 8.33-.4 17.9.49 26.16.28 2.58 4.31 4.26 5.63 6.4 2.9 4.7 4.14 10.64 7.36 15.32 2.91 4.21 7.99 6.75 10.95 11.02 5.21 7.55-1.2 18.1-5.08 24.38"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1696.46 1083.56c-.75-.37 20.83 4.68 26.88 5.35 10.75 1.2 19.35.3 29.49 2.95 3.16.82 11.02 7.11 13 9.09"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1773.37 1197.57c.23 1.51 8.27 21.64 6.32 18.87"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1786.73 1194.06c-1.57 4.6-2.95 10.69-3.5 15.57-.93 8.28-5.97 16.24-6.93 24.78-.66 5.91-.22 12.37-1.67 18.12-.93 3.68-3.96 7.42-5.58 11.18-1.87 4.33-2.45 9.89-5.26 13.57-1.59 2.08-1.82 6.92-2.46 9.46-1.17 4.64-4.83 9.7-5.35 14.33-.48 4.23-1.57 8.87-2.73 13.03-1.92 6.92-6.34 21.66-4.35 28.73 2.63 9.3 11.21 24.46 17.47 31.58 5.09 5.79 14 11.56 20.69 15.3 7.62 4.27 14.64 11.18 21.6 16.49 4.51 3.45 9.36 7.24 13.09 11.48 2.42 2.75 4.09 6.44 7.45 8.32 9.53 5.33 22.55-5.28 32.75-1.78"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1856.5 1165.32c-1.5 4.37-2.48 10.46-3 15.13-.63 5.56-2.92 13.09-4.79 18.53-3.16 9.23-3.51 20.29-5.32 29.79-3.04 15.95-2.48 32.77-8.8 48.34-2.86 7.03-7.63 18.67-8.09 25.87-.26 3.98 2.94 8.63 4.07 12.31 1.5 4.87 1.53 6.32.59 11.29-.22 1.12-3.2 6.42-2.21 4.4"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1803.91 1323.53c-2.47.33.14 1.62 1.57 2.02 6.33 1.77 13.45 1.17 19.76 2.76 6.78 1.71 10.19 8.93 15.53 13.01 4.62 3.53 9.06 7.74 13.83 11.38 3.08 2.35 6.87 3.32 10.49 4.56.94.32 5.46 1.28 4.43 1.08"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1861.82 1423.1c-1-.5 1.02-4.44 1.47-5.32 2.05-4.1 8.85-5.68 10.1-10.65 3.23-12.94 5.91-23.62 3.67-37.09-.37-2.22-1.08-5.84-2.76-7.52"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1862.37 1423.65c-.37-.18 3.68.58 4.77.74 3.13.44 9.17 1.8 11.02-1.29 2.4-3.99 6.24-9.91 9.55-13.22 1.29-1.3 2.91-1.96 3.67-3.85 2.8-7 2.02-18.66 2.02-26.26"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1880.36 1419.98c-.89.45 1.58 1.31 2.02 2.2 1.19 2.39 2.13 4.81 3.31 7.16 3.7 7.42 7.6 16.35 9.91 24.42.34 1.2 1.84 2.27 1.84 3.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1654.47 1692.47c-.45-.89 10.02-26.79 11.15-31.3 3.75-15.02 6.39-30.27 9.43-45.45.75-3.78 3.34-7.37 4.29-11.15 3.97-15.9 7.28-32.64 7.28-49.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1677.9 1514.88c11.95 10.68 28.75 19.92 44.97 20.26 5.17.11 9.81-4.34 14.71-4 6.17.42 12.34 1.87 18.51 2.63 9.05 1.13 17.75.97 26.72.47 3.03-.17 13.2-.37 12.1-.31"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1781.87 1632.88c-1.02.25-.69.35-1.63-1.09-3.63-5.59-4.83-14.48-7.81-20.57-2.36-4.83-2.79-10.91-5.15-15.75-5.71-11.67-9.39-24.24-15.1-35.92-3.09-6.31-8.61-14.6-10.23-21.34"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1820.5 1608.45c-2.69-1.16-2.49-7.05-3.95-9.72-3.96-7.19-8.59-15.44-11.2-23.34-1-3.03-.9-6.64-2.44-9.58-3.2-6.15-7.33-14.15-9.32-20.7-.27-.88-1.26-5.26.39-4.56"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1825.24 1622.44c-.44.1 2.4 7.9 2.24 7.27"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1834.93 1663.66c2.19 8.75 7.77 17.5 10.54 26.33 10.39 33.15 22.19 66.86 30.61 100.54"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1870.28 1830.46c1.35 14.4 1.19 29.54.75 43.92-.15 5 1.6 9.9 2.07 14.84 1.57 16.75 3.78 34.22 8.31 50.39 2.34 8.33 6.13 16.33 8.59 24.56 4.28 14.29 9.8 28.85 15.24 42.78 1.86 4.78 3.61 9.42 4.71 14.37.36 1.65 1.1 3.22 1.57 4.79.12.39.69 2.55.59 1.52"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1861.96 1842.24c-.48.3-1.31-.24-1.16-.34.33-.2 17.22-.05 19.5-.26 13.69-1.28 26.13 3.04 39.35 5.51 3.06.57 7.61 1.52 10.62.8.62-.15 6.21-3.18 6.39-1.27 0 .02-6.02-2.22-6.28-2.33-3.39-1.46-6.72-3.1-10.27-4.2-10.61-3.3-22.38-4.59-31.19-11.89-2.49-2.06-5.61-3.81-8.37-5.5-.84-.51-5.26-2.27-3.72-1.44"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1846.18 1843.94c-3.86-.89 6.89-10.56 6.87-10.52"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1548.15 2093.26c-1.44-1.05 2.84.44 4.05 1.46 2.15 1.84 5.47 4.8 8.09 5.79 1.42.54 10.11 2.17 9.71 2.72"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1578.2 2116.02c-1.07 1.47.88 10.47 1.07 12.72.77 9.59 3.06 23.8-2.93 32.06"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1579.16 2154.28c6.92-2.14 12.49-12.08 15.49-17.76"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1569.08 2043.04c-.17.02 1.09.02 1.57-.01 1.13-.05 2.14-.12 3.22-.26"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1924.23 2066.86c-.17-.14-1.21-.29-.98.09.64 1.04 5.41.01 6.46-.23 3.2-.76 9.13-1.88 11.91-3.59"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1672.45 1100.92c9.87 5.69 23.8 8.36 38.15 8.72 15.19.39 34.71 4.57 47.66-.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1625.58 1206.11c-1.1 8.13 4.88 17.95 5.55 25.98.45 5.37 3.69 10.48 4.57 15.82 2.14 12.98 8.69 25.06 15.03 35.99 2.36 4.06 3.9 8.86 7.03 12.5 3.03 3.54 7.89 2.37 10.52 4.97"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1677.16 1116.23c2.05 6.04.35 12.59.87 18.74.38 4.53 1.35 8.93 1.58 13.54.2 3.91-1.08 8.23-.58 12.06.47 3.57 1.31 8.57.83 12.13"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1680.42 1181.62c4.76 13.97 10.47 28.24 17.13 41.34 4.57 8.98 6.65 19.29 13.4 27.16 5.02 5.84 7.18 14.41 10.8 21.15 1.06 1.96 5.08 10.85 4.19 8.23"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1703.83 1157.85c1.5-3.69 16.91 2.38 23.01.77"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1692.41 1334.02c.8-.31 9.39 5.48 10.83 6.31 10.95 6.29 20.43 15.08 31.91 20.59 6.34 3.05 12.76 6.17 18.91 9.48 1.93 1.05 3.75 2.24 5.61 3.39.44.27 3.38.81 2.64 1.1"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1743.52 1351.14c1.34.83 14.5 12.48 15.05 13.9"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1626.62 1374.23c1.28 3.84 11.33 14.18 11.33 15.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1642.56 1507c-.31-.74 4.6-.18 5.97.06 2.64.45 6.92-.69 9.32-1.69"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1647.69 1535.95c.24-.96 3.46.37 4.62.28 2.53-.19 5.56-1.88 7.18-3.76"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1653.47 1563.61c-2.16-.54 2.81-6.43 3.31-7.33 2.93-5.18 6.26-9.46 5.78-15.84"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1943.66 1811.94s9.37 46.33 17.9 99.78c8.54 53.46 16.25 114.03 16.25 114.03"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;